import { Injectable } from '@angular/core';
import { buttonsFirst, buttons, buttonsLast } from '../botones';

@Injectable({ providedIn: 'root' })
export class StepsConfiguracion {
  constructor() {
    this.crear();
  }

  crear() {
    return [
      {
        attachTo: {
          element: '.step_100',
          on: 'bottom' as const,
        },
        title: 'CONFIGURACIÓN',
        text: `
            En esta página puede cambiar las opciones predeterminadas de los ENVÍOS y el tema visual del PANEL de CONTROL.
        `,
        buttons: buttonsFirst,
      },
      {
        attachTo: {
          element: '.step_200',
          on: 'bottom' as const,
        },
        title: 'OPCIONES DE LOS ENVÍOS',
        text: `
            En esta puede seleccionar las opciones por defecto utilizadas en los nuevos envíos.  Podrá cambiarlas posteriormente durante el proceso de envío.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_300',
          on: 'bottom' as const,
        },
        title: 'RECIBIR DOCUMENTOS POR EMAIL',
        text: `
            Si se marca esta opción, recibirá en su correo en un archivo comprimido la información completa del envío.
            Siempre podrá descargarlo igualmente desde la sección de envíos, pulsando en VER DETALLES
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_400',
          on: 'bottom' as const,
        },
        title: 'RECIBIR NOTIFICACIONES POR EMAIL',
        text: `
            Si se marca esta opción, los cambios de estado del envío le serán notificados por email.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_500',
          on: 'bottom' as const,
        },
        title: 'ENVIAR COPIA AL DESTINATARIO POR EMAIL',
        text: `
            Si se marca esta opción, se enviará un certificado RESUMIDO al firmante.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_550',
          on: 'bottom' as const,
        },
        title: 'OPCIONES DE LOS DESTINATARIOS',
        text: `
            Aquí puede configurar qué información adicional se solicitará al destinatario durante el proceso de firma.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_560',
          on: 'bottom' as const,
        },
        title: 'SOLICITAR FIRMA MANUSCRITA',
        text: `
            Si se activa, el destinatario deberá realizar una firma manuscrita (dibujada) como prueba adicional durante el proceso de firma del documento.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_570',
          on: 'bottom' as const,
        },
        title: 'SOLICITAR DOCUMENTO DE IDENTIFICACIÓN MRZ',
        text: `
            Si se activa, se le pedirá al destinatario que escanee su DNI, pasaporte u otro documento de identidad con tecnología MRZ, añadiéndolo como evidencia adicional al certificado.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_600',
          on: 'bottom' as const,
        },
        title: 'SELECCIÓN DEL TEMA',
        text: `
            Seleccione el tema por defecto de la aplicación.  Puede alternar entre el tema CLARO y el OSCURO.
                    `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_800',
          on: 'bottom' as const,
        },
        title: 'GUARDAR',
        text: `
            Una vez seleccionadas las opciones que desee pulse aquí para guardarlas.
        `,
        buttons: buttonsLast,
      },
    ];
  }
}
